module.exports = __webpack_public_path__ + "img/logo3.863064f1.png";